import React, { useState, useEffect } from "react";
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import * as Icon from "react-feather";
import axiosConfig from "../../../axiosConfig";
import defaultimage from "../../../assets/img/logo/diagnostic.png.png";

const NavbarUser = () => {
  const [adminimg, setAdminimg] = useState(null);

  // ================= TOKEN CHECK =================
  const tokenVerify = () => {
    const token = localStorage.getItem("ad-token");
    if (!token) {
      window.location.replace("/#/pages/login");
    }
  };

  // ================= GET PROFILE DATA =================
  useEffect(() => {
    tokenVerify();

    const getUserData = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        // console.log("1. UserData from LocalStorage:", userData);

        if (userData && userData._id) {
          const res = await axiosConfig.get(
            `/diagnostic/diagnostic-by-id/${userData._id}`,
          );

          // console.log("2. API Response:", res.data);

          if (res.data?.Diagnostic) {
            setAdminimg(res.data.Diagnostic);
            // console.log("3. Diagnostic Set:", res.data.Diagnostic);
          }
        }
      } catch (error) {
        console.error("!!! Navbar API Error:", error);
      }
    };

    getUserData();
  }, []);

  // ================= IMAGE URL FIX =================
  const baseURL = axiosConfig.defaults.baseURL;
  const imageUrl = adminimg?.image
    ? `${baseURL.endsWith("/") ? baseURL : baseURL + "/"}Images/${adminimg.image}`
    : "";

  // console.log("4. Final Image URL:", imageUrl);

  return (
    <ul className="nav navbar-nav navbar-nav-user float-right">
      <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
        <DropdownToggle tag="a" className="nav-link dropdown-user-link">
          <div className="user-nav d-sm-flex d-none">
            <span className="user-name text-bold-600">
              {adminimg?.name || "Loading..."}
            </span>
          </div>

          <span data-tour="user">
            <img
              src={imageUrl || defaultimage}
              className="round"
              height="40"
              width="40"
              alt="avatar"
              onError={(e) => {
                console.log("!!! Image load failed, using default");
                e.target.onerror = null;
                e.target.src = defaultimage;
              }}
            />
          </span>
        </DropdownToggle>

        <DropdownMenu right>
          <DropdownItem
            tag="a"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.location.replace("/#/Editprofile");
            }}
          >
            <Icon.User size={14} className="mr-50" />
            <span className="align-middle">Edit Profile</span>
          </DropdownItem>

          <DropdownItem divider />

          <DropdownItem
            tag="a"
            onClick={() => {
              localStorage.removeItem("ad-token");
              localStorage.removeItem("userData");
              window.location.replace("/#/pages/login");
            }}
          >
            <Icon.Power size={14} className="mr-50" />
            <span className="align-middle">Log Out</span>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </ul>
  );
};

export default NavbarUser;
